import {USER_UNSET} from '~/frontend/src/constants';

export type UnsetUserAction = {
    type : typeof USER_UNSET;
}

/**
 * @memberOf! Actions
 *
 * @return {UnsetUserAction}
 */
const unsetUser = () : UnsetUserAction => {
    return {
        type: USER_UNSET
    };
}

export type UnsetUser = typeof unsetUser;

export default unsetUser;
